import * as filterOptions from "features/Application/actions/filterOptions/filterOptionsActionTypes";

type StateType<T> = T & {
  isLoading?: boolean;
  error?: Error;
};

const withFilterOptions =
  <T extends {} = { [key: string]: unknown }>(
    namespace: string,
    entityPrefix: string,
  ): ((state: StateType<T>, action: { type: string; payload: T | { error: Error } }) => StateType<T>) =>
  (state, action) => {
    const { type, payload } = action;

    switch (type) {
      case `${namespace}__${entityPrefix}__${filterOptions.FETCH_OPTIONS_BEGIN}`:
        return {
          ...state,
          isLoading: true,
        };
      case `${namespace}__${entityPrefix}__${filterOptions.FETCH_OPTIONS_SUCCESS}`:
        return {
          ...state,
          isLoading: false,
          ...payload,
        };
      case `${namespace}__${entityPrefix}__${filterOptions.FETCH_OPTIONS_FAILURE}`:
        return {
          ...state,
          error: "error" in payload ? payload.error : undefined,
          isLoading: false,
        };
      default:
        return { ...state };
    }
  };

export default withFilterOptions;
